import type { ReactNode } from 'react'
import type { PatchScope } from '@/types/patching'
import styles from './Patching.module.css'

function Chips({ values, mono = false }: { values: string[]; mono?: boolean }) {
  if (values.length === 0) return <span className={styles.muted}>none</span>
  return (
    <span className={styles.chips}>
      {values.map((v) => (
        <span key={v} className={mono ? `${styles.chip} ${styles.chipMono}` : styles.chip}>
          {v}
        </span>
      ))}
    </span>
  )
}

function Fact({ label, children }: { label: string; children: ReactNode }) {
  return (
    <div>
      <dt className={styles.factLabel}>{label}</dt>
      <dd className={styles.factValue}>{children}</dd>
    </div>
  )
}

/** Read-only summary of the patch scope plus the hash every approval is bound to. */
export function ScopeSummary({ scope, scopeHash }: { scope: PatchScope; scopeHash: string }) {
  return (
    <div data-testid="scope-summary">
      <dl className={styles.factGrid}>
        <Fact label="Windows classifications">
          <Chips values={scope.classifications.windows} />
        </Fact>
        <Fact label="Linux classifications">
          <Chips values={scope.classifications.linux} />
        </Fact>
        <Fact label="Reboot setting">{scope.reboot_setting}</Fact>
        <Fact label="Max publish date">{scope.max_patch_publish_date ?? 'No limit'}</Fact>
        <Fact label="KB include">
          <Chips values={scope.kb_numbers_to_include} mono />
        </Fact>
        <Fact label="KB exclude">
          <Chips values={scope.kb_numbers_to_exclude} mono />
        </Fact>
        <Fact label="Package masks include">
          <Chips values={scope.package_name_masks_to_include} mono />
        </Fact>
        <Fact label="Package masks exclude">
          <Chips values={scope.package_name_masks_to_exclude} mono />
        </Fact>
        <Fact label="Applications">
          <Chips values={scope.applications} mono />
        </Fact>
      </dl>
      <div style={{ marginTop: 14 }}>
        <span className={styles.factLabel}>Scope hash (SHA-256 — every approval is bound to this)</span>
        <p className={styles.hash} data-testid="scope-hash">{scopeHash || '—'}</p>
      </div>
    </div>
  )
}
